import React, { useState } from 'react';
import FormIndex from '../forms/FormIndex';
import UserRoles from '../roles/UserRoles';
import Row from '../common/Row';
import TimeStamp from '../common/TimeStamp';
import Breadcrumbs from '../common/Breadcrumbs';
import ContainerEdit from './ContainerEdit';
import Icon from '../common/Icon';
import { userCan } from '../../helpers/rolePermissions';
import { UserContext } from '../../hooks/Contexts';
import { useLoaderData, useRevalidator } from 'react-router-dom';

const ContainerShow = () => {
  const { data } = useLoaderData();
  const revalidator = useRevalidator();
  const reloadContainerData = () => revalidator.revalidate();
  const { forms, current_user, permission } = data;
  const [container, setContainer] = useState(data.container);
  const [roles, setRoles] = useState(data.roles);
  const [editing, setEditing] = useState(false);
  const user = { ...userCan(current_user, permission) };

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const { display_name, name, slug, active, archived, created_at, updated_at } =
    container;

  return (
    <UserContext.Provider value={user} key={data.container.updated_at}>
      {/* use container.updated as key in Provider to force a rerender when container is updated */}
      <Breadcrumbs container={{ name: name, id: container.id }} />
      {editing ? (
        <ContainerEdit
          container={container}
          toggleEdit={toggleEdit}
          setContainer={setContainer}
          reloadContainerData={reloadContainerData}
        />
      ) : (
        <div className='details'>
          {user.isAdmin && (
            <div className='controls'>
              <Icon className='edit' onClick={toggleEdit} icon='pencil' />
            </div>
          )}
          <Row name='Display Name:' value={display_name} />
          <Row name='Name:' value={name} />
          <Row name='Permalink:' value={window.location.origin + '/' + slug} />
          <Row name='Active:' value={active ? 'Yes' : 'No'} />
          <Row name='Archived:' value={archived ? 'Yes' : 'No'} />
          <TimeStamp title='Created' value={created_at} />
          <TimeStamp title='Updated' value={updated_at} />
        </div>
      )}

      {user.isAdmin && (
        <UserRoles
          roles={roles}
          setRoles={setRoles}
          container_id={container.id}
        />
      )}
      <FormIndex formsProp={forms} container={container} />
    </UserContext.Provider>
  );
};

export default ContainerShow;
